import React from 'react';
import { FaTrash, FaPen, FaCalendarAlt } from 'react-icons/fa';

const TaskItem = ({ task, onDelete, onToggle, onEdit }) => {
    const [isConfettiActive, setIsConfettiActive] = React.useState(false); // Add React.useState if not imported, or just useState if it is. 
    // Wait, I need to check imports. The file uses `import { FaTrash... }`. It doesn't import useState.
    // I need to add useState to imports first.

    const categoryStyles = {
        // Legacy (English)
        Worship: { label: 'Adoration', color: '#1B7A6E', bg: '#E8F5E9' },
        Work: { label: 'Travail', color: '#0984e3', bg: '#E3F2FD' },
        Family: { label: 'Famille', color: '#e17055', bg: '#FBE9E7' },
        Other: { label: 'Autre', color: '#636E72', bg: '#F5F6FA' },
        // Modern (French)
        Adoration: { label: 'Adoration', color: '#1B7A6E', bg: '#E8F5E9' },
        Travail: { label: 'Travail', color: '#0984e3', bg: '#E3F2FD' },
        Famille: { label: 'Famille', color: '#e17055', bg: '#FBE9E7' },
        Autre: { label: 'Autre', color: '#636E72', bg: '#F5F6FA' }
    };

    const getCategoryStyle = (cat) => {
        if (!cat) return categoryStyles.Other;
        if (categoryStyles[cat]) return categoryStyles[cat];
        // Custom Category
        return { label: cat, color: '#6c5ce7', bg: '#e0dcfc' };
    };

    const categoryStyle = getCategoryStyle(task.category);

    return (
        <div className={`task-item card ${task.completed ? 'completed' : ''}`}>
            <div className="task-content-wrapper">
                <div
                    className={`checkbox-custom ${task.completed ? 'checked' : ''} ${isConfettiActive ? 'confetti' : ''}`}
                    onClick={() => {
                        if (!task.completed) {
                            setIsConfettiActive(true);
                            setTimeout(() => setIsConfettiActive(false), 600);
                        }
                        onToggle(task);
                    }}
                >
                    {task.completed && <span>&#10003;</span>}
                </div>

                <div className="task-info">
                    <h3 className="task-title">{task.text}</h3>
                    {task.description && <p className="task-description">{task.description}</p>}

                    <div className="task-meta">
                        <span
                            className="task-badge"
                            style={{ color: categoryStyle.color, backgroundColor: categoryStyle.bg }}
                        >
                            {categoryStyle.label}
                        </span>
                        {task.dueDate && (
                            <span className="task-date">
                                <FaCalendarAlt /> {new Date(task.dueDate).toLocaleDateString('fr-FR')}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <div className="task-actions-hover">
                <button onClick={() => onEdit(task)} className="btn-icon" title="Modifier">
                    <FaPen />
                </button>
                <button onClick={() => onDelete(task._id)} className="btn-icon delete" title="Supprimer">
                    <FaTrash />
                </button>
            </div>
        </div>
    );
};

export default TaskItem;
